export default "__VITE_ASSET__BYeal5uh__"